<template>
    <div class="modalitem-search">
        <b-form>
            <b-row>
                <b-col md="8" sm="8">
                    <b-form-group label="Nome:" label-for="entity-name_entity">
                    <b-form-input 
                        id="entity-name_entity" 
                        type="text"
                        v-model="entity_search.name_entity"
                        size="sm"
                        :readonly= 'true'
                        placeholder="Nome..." />
                    </b-form-group>
                </b-col> 
                    <b-col md="4" sm="2">
                    <b-form-group label="CPF/CNPJ/Banco/Caixa:" label-for="entity-cnpj_cpf">
                    <b-form-input id="entity-cnpj_cpf" type="text"
                        v-model="entity_search.cnpj_cpf"
                        size="sm"
                        :readonly= 'true'
                        placeholder="" />
                    </b-form-group>
                </b-col>  
            </b-row>
            <b-row>
                <div class="col-sm-8">
                    <div class="form-group">
                        <b-form-select 
                            id="search-type_entity_id"
                                    @input="[loadEntitys(),showEntity=true]"
                                    size="sm"
                                    class="mb-2"
                                    :options="typeentitys" 
                                    v-model="type_entity_id" />
                        <input 
                            type="text" 
                            icon="search" 
                            autofocus
                            v-on:keyup.enter="[focusAdd()]"
                            v-model="searchEntity" 
                            ref="inputFist"
                            placeholder="Informe o nome / CPF-CNPJ" 
                            class="form-control">
                    </div>
                </div>
            </b-row>  
            <transition name="slide" type="animation" appear>
            <b-table 
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover  
                v-show="showEntity" 
                :items="filteredList" 
                :fields="fieldsEntity">
                <template v-slot:cell(actions)="data">
                        <b-button 
                             
                            title = "Selecionar o registro" 
                            size="sm" 
                            variant="dark" 
                            @click="[setSearchEntity(data.item),showEntity = !showEntity]" 
                            class="mr-2 mt-2">
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                </template>   
            </b-table>
            </transition>
            <transition  name="slide" type="animation" appear>
                
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition> 
        </b-form>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: 'EntitySearchModal',
    props:['entity_id'],
    data: function() {
        return {
            searchEntity: '',
            showEntity: false,
            fieldsEntity: [
                    { key: 'id', label: 'Código', sortable: true },
                    { key: 'name_entity', label: 'Nome', sortable: true, variant: 'secondary' },
                    { key: 'fantasy_name', label: 'Nome Fantasia', sortable: true },
                    { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                    { key: 'blocked', label: 'Bloqueado', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },               
                    { key: 'actions', label: 'Ações', variant: 'light' }
                ],
            perPage: 3,
            currentPage: 1,
            entity_search:{},
            type_entity_id: null,
            entitys: [],
            typeentitys: []
        }
    },
     computed: {
        filteredList() {
               return this.entitys.filter(entity => {
                    return ( 
                        entity.name_entity.toLowerCase().includes(this.searchEntity.toLowerCase()) || 
                        entity.cnpj_cpf.toLowerCase().includes(this.searchEntity.toLowerCase())
                    )
                    })
        },rows() {
            return this.entitys.length
        },
        compan(){
            return this.$store.state.compan
        },
    },
    methods: {
            async loadEntitys(){
                if (!this.compan) {
                     this.$toasted.global.defaultWarning({msg:'Logar na empresa'})
                }else{
                     const url = `${baseApiUrl}/entitysallcompany/${this.compan.id}?type_entity_id=${this.type_entity_id}`
                await axios.get(url).then(res => {
                      this.entitys = res.data
                  })
                }
                this.$refs.inputFist.focus();
            },
            async loadTypeEntitys() {

                const url = `${baseApiUrl}/typeentitysall`
                await axios.get(url).then(res => {
                    this.typeentitys = res.data.map(typeentity => {
                        return { value: typeentity.id, text: typeentity.name }
                        })
                    })
            },
             setSearchEntity(entity) {
              this.entity_search.name_entity = entity.name_entity
              this.entity_search.cnpj_cpf = entity.cnpj_cpf
              this.$emit('setEntityId',entity.id)
              this.$emit('setEntityName',entity.name_entity)
              this.$emit('setEntityCnpjCpf',entity.cnpj_cpf)
              
            },
    },
    mounted() {
       this.loadTypeEntitys()
       this.type_entity_id = 1
    }
}
</script>

<style>


    .modalitem-search select{
        font-size: 0.75rem;
    }
    .modalitem-search input{
        font-size: 0.75rem;
    }
    .modalitem-search button{
        font-size: 0.75rem;
    }
    .modalitem-search table{
        font-size: 0.75rem;
    }

    
    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
}

</style>
